"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _dragm = _interopRequireDefault(require("dragm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class DraggableTitle extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "updateTransform", transformStr => {
      //require trnsformation logic to restrict modal to drag out of window
      let orignalTransform = transformStr;
      let slicedTransformString = orignalTransform.substring("10").slice(0, -1).split(",");
      let xPx = slicedTransformString[0].replace("px", "");
      let yPx = slicedTransformString[1].replace("px", "");
      if (xPx < -300) {
        xPx = -300;
      }
      if (xPx > 300) {
        xPx = 300;
      }
      if (yPx < -22) {
        yPx = -22;
      }
      if (yPx > 530) {
        yPx = 530;
      }
      var result = "translate(";
      result = result.concat(xPx, "px,", yPx, "px)");
      this.modalDom.style.transform = result;
    });
  }
  componentDidMount() {
    if (document.getElementsByClassName("ant-modal-wrap")) {
      let antModalWrap = document.getElementsByClassName("ant-modal-wrap");
      let modalLength = antModalWrap.length - 1;
      let modalDom = antModalWrap[modalLength];
      this.modalDom = modalDom;
    }
  }
  render() {
    const {
      title
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_dragm.default, {
      updateTransform: this.updateTransform
    }, /*#__PURE__*/_react.default.createElement("div", null, title));
  }
}
var _default = exports.default = DraggableTitle;